<template>
  <v-row justify="center" class="d-flex flex-row">
    <v-card width="280" class="ma-3" href="mailto:panman28@gmail.com" color="#E84F4B">
      <v-row justify="center" align="center">
        <v-col cols="6">
          <v-img
            max-height="130"
            max-width="130"
            src="@/assets/img/contact/gmail.png"
            class="ml-2 my-2"
            contain
          ></v-img>
        </v-col>
        <v-col cols="6" class="text-center">
          <p class="text-h4 my-auto white--text">Gmail</p>
        </v-col>
      </v-row>
    </v-card>
    <v-card width="280" class="ma-3" href="https://github.com/panman11111" color="#696969">
      <v-row justify="center" align="center">
        <v-col cols="6">
          <v-img
            max-height="130"
            max-width="130"
            src="@/assets/img/contact/GitHub.png"
            class="ml-2 my-2"
            contain
          ></v-img>
        </v-col>
        <v-col cols="6" class="text-center">
          <p class="text-h4 my-auto">GitHub</p>
        </v-col>
      </v-row>
    </v-card>

    <v-card width="280" class="ma-3" light href="https://docs.google.com/forms/d/e/1FAIpQLSeDAIWS6ZQkh2YXv8Tt9Q--QDXnu0t860pVex2RlJB4gxVvwg/viewform?vc=0&c=0&w=1&flr=0" color="#7248B9">
      <v-row justify="center" align="center">
        <v-col cols="6">
          <v-img
            max-height="130"
            max-width="130"
            src="@/assets/img/contact/Forms.png"
            class="ml-1 my-1 "
            contain
          ></v-img>
        </v-col>
        <v-col cols="6" class="text-center">
          <p class="text-h6 my-auto text-no-wrap white--text">
            お問い合わせ
            <br>
            フォーム</p>
        </v-col>
      </v-row>
    </v-card>
    <v-card width="280" class="ma-3" href="https://twitter.com/pan_work11111" color="rgb(29,161,242)">
      <v-row justify="center" align="center">
        <v-col cols="6">
          <v-img
            max-height="130"
            max-width="130"
            src="@/assets/img/contact/twitter.png"
            class="ml-2 my-2"
            contain
          ></v-img>
        </v-col>
        <v-col cols="6" class="text-center ">
          <p class="text-h4 my-auto white--text">twitter</p>
        </v-col>
      </v-row>
    </v-card>
    <v-card width="280" class="ma-3" href="https://pan-weblog.com/" color="rgb(9,59,200)">
      <v-row justify="center" align="center">
        <v-col cols="6">
          <v-img
            max-height="130"
            max-width="130"
            src="@/assets/img/contact/Blog.png"
            class="ml-2 my-2"
            contain
          ></v-img>
        </v-col>
        <v-col cols="6" class="text-center ">
          <p class="text-h4 my-auto white--text">Blog</p>
        </v-col>
      </v-row>
    </v-card>
  </v-row>
</template>


<script>
export default {
  data: () => ({
    show: false,
  }),
};
</script>